<template>
  <el-dialog title="回复" :visible.sync="visible" width="40%">
    <el-form :model="data" :rules="rules" ref="addForm" label-width="0">
      <el-form-item prop="replyContent">
        <el-input
          type="textarea"
          :maxlength="100"
          v-model="data.replyContent"
          placeholder="请输入回复内容"
          show-word-limit
          :rows="4"
          clearable
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import { replyComment } from "@/api/saas/package";


export default {
  name: "AddClueDialog",
  components: {
  },
  props: {},
  data() {
    return {
      visible: false,
      rules: {
        replyContent: [
          { required: true, message: "请输入回复内容", trigger: "change" }
        ]
      },
      data: {
        replyContent: null,
        commentId: null
      }
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  watch: {
    visible(val) {
      if (!val) {
        this.resetForm("addForm");
      }
    }
  },
  methods: {
    open(commentId) {
      this.visible = true;
      this.data.commentId = commentId
    },
    confirm() {
      this.$refs["addForm"].validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "加载中",
            spinner: "el-icon-loading"
          });
          replyComment(this.data)
            .then(response => {
              this.visible = false;
              this.$emit("success");
              loading.close();
              this.msgSuccess("回复成功");
            })
            .catch(error => {
              loading.close();
            });
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    }
  }
};
</script>
